<template>
<!-- 상태 변경 팝업 -->
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div>
                        <p class="bold dp-inblock h-30px font-23">알림톡 문구</p>
                        <a class="pointer float-right layer-close ml-30" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                            <img src="../../assets/img/close.png" alt="close" class="close-btn">
                        </a>
                        <p class="font-13 pt-10">
                            - 원하는 문구 클릭 시 자동으로 반영됩니다.
                        </p>

                        <div class="mt-30">
                            <table class="admin-table-col mt-10">
                                <colgroup>
                                    <col width="100px">
                                    <col width="*">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>구분</th>
                                        <th>알림톡 내용</th>
                                    </tr>
                                </thead>
                                <tbody class="txt-center">
                                    <!-- <tr>
                                        <td width="100">결제완료</td>
                                        <td class="txt-left preline pointer" @click="applySMSText($event)" data-dismiss="modal">[캐럿글로벌] 안녕하세요, ㅇㅇㅇㅇ과정 결제 완료 안내 드립니다.

                                            결제 완료 및 수강신청 내역은 수강신청 페이지 (URL) 에서 확인 하실 수 있습니다.

                                            감사합니다.
                                            캐럿글로벌 ㅇㅇㅇ 매니저 드림.
                                        </td>
                                    </tr> -->
                                    <tr>
                                        <td width="100">결제취소</td>
                                        <td class="txt-left preline pointer" @click="applySMSText($event)" data-dismiss="modal">[캐럿글로벌] 안녕하세요, ㅇㅇㅇㅇ과정 결제 취소 안내 드립니다.

                                            결제취소 일시 : 0000. 00. 00

                                            카드 결제일 경우 카드사에 따라 영업일 기준 3~5일 정도 소요되며, 자세한 일정은 카드사에 문의 부탁 드립니다.
                                            실시간 계좌이체 일 경우, 환불 처리가 완료되면 결제에 이용한 계좌로 입금되며, 평일 기준 1~2일 소요될 수 있습니다.

                                            감사합니다.
                                            캐럿글로벌 ㅇㅇㅇ 매니저 드림.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="100">신청완료</td>
                                        <td class="txt-left preline pointer" @click="applySMSText($event)" data-dismiss="modal">[캐럿글로벌] 안녕하세요, ㅇㅇㅇㅇ과정이 신청 완료 되었습니다.

                                            수강신청 내역은 수강신청 페이지 (URL)에서도 확인 하실 수 있습니다.

                                            이후 입과 안내는 별도 안내 드릴 예정이며,
                                            수강신청 취소는 담당 매니저에게 연락 부탁 드립니다.

                                            감사합니다.
                                            캐럿글로벌 ㅇㅇㅇ 매니저 드림.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="100">수강취소</td>
                                        <td class="txt-left preline pointer" @click="applySMSText($event)" data-dismiss="modal">[캐럿글로벌] 안녕하세요, ㅇㅇㅇㅇ과정 수강 취소 안내 드립니다.

                                            수강취소 일시 : 0000. 00. 00

                                            다음에 더 좋은 과정으로 찾아 뵙겠습니다.

                                            감사합니다.
                                            캐럿글로벌 ㅇㅇㅇ 매니저 드림.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer txt-center">
                        <a class="pointer admin-btn-default btn ml-05" @click="$emit('close')" data-dismiss="modal" aria-label="Close">확인</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    data: () => ({

    }),

    methods: {
        // SMS 문구 전송
        applySMSText(event) {
            console.log('event.srcElement.innerText', event.srcElement.innerText)
            this.$emit('applySMSText', event.srcElement.innerText)
        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        background: #fff;
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }

    &-footer {
        // background: #ccc;
        padding: 10px;
        text-align: right;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
